import {
    TOGGLE_SEARCH_PLANT,
    TOGGLE_FILTER_PLANT
} from '../actions'

const notSpecifiedFilter = 'NOT_SPECIFIED'

const INITIAL_STATE = {
    filters: {
        favorites: false,
        waterdemand: notSpecifiedFilter,
        location: notSpecifiedFilter,
        cuttingtime: notSpecifiedFilter,
    },
    active: false,
}

function SearchReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case TOGGLE_SEARCH_PLANT:
            return {
                ...state,
                active: action.payload,
            }
        case TOGGLE_FILTER_PLANT:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.payload.name]: action.payload.active,
                },
            }
        default: return state
    }
}

export default SearchReducer



// WEBPACK FOOTER //
// ./src/reducers/search.js